module.exports = __webpack_public_path__ + "static/media/filter.8cacf9e7.svg";